export const NAV = {
  home: "nav-home",
  masszazs: "nav-masszazs",
  fourlife: "nav-fourlife",
  forever: "nav-forever",
  blog: "nav-blog",
  facebookHeader: "nav-facebook-button",
  facebookFooter: "footer-facebook-button",
  mobileMenuToggle: "nav-mobile-toggle",
  mobileMenuPanel: "nav-mobile-panel",
};

export const HOME = {
  hero: "hero-section",
  heroCta: "hero-cta-button",
  magnetsSection: "magnets-section",
  magnetCard: (k) => `magnet-card-${k}`,
  magnetSelect: (k) => `magnet-select-${k}`,
  servicesPreview: "services-preview-section",
  contactSection: "contact-section",
  contactEmail: "contact-email-link",
  contactFacebook: "contact-facebook-link",
};

export const FORM = {
  section: "subscribe-section",
  name: "subscribe-form-name-input",
  email: "subscribe-form-email-input",
  consent: "subscribe-form-consent-checkbox",
  submit: "subscribe-form-submit-button",
  success: "subscribe-form-success",
  ebookDownload: "ebook-download-button",
  ebookView: "ebook-view-button",
  modalClose: "subscribe-modal-close",
};

export const MASSAGE = {
  page: "masszazs-page",
  card: (k) => `massage-card-${k}`,
  bookBtn: (k) => `book-btn-${k}`,
};

export const FOURLIFE = {
  page: "fourlife-page",
  card: (k) => `fourlife-card-${k}`,
  detailsBtn: (k) => `fourlife-details-${k}`,
};

export const BLOG = {
  page: "blog-page",
  articleCard: (k) => `blog-article-${k}`,
  videoCard: (k) => `blog-video-${k}`,
  fbVideoBtn: (k) => `fb-video-btn-${k}`,
};

// Legacy keys (kept for backward-compat with existing tests)
export const LANDING = {
  hero: HOME.hero,
  heroCta: HOME.heroCta,
  heroLogo: "hero-logo-image",
  navLogo: "nav-logo-link",
  navSubscribe: NAV.home,
  navContact: HOME.contactSection,
  leadMagnet: HOME.magnetsSection,
  servicesSection: HOME.servicesPreview,
  formSection: FORM.section,
  formName: FORM.name,
  formEmail: FORM.email,
  formConsent: FORM.consent,
  formSubmit: FORM.submit,
  formSuccess: FORM.success,
  formError: "subscribe-form-error",
  contactSection: HOME.contactSection,
  contactFacebook: HOME.contactFacebook,
  contactInstagram: "contact-instagram-link",
  contactEmail: HOME.contactEmail,
  footer: "site-footer",
};
